import { singleton } from 'tsyringe';
import { ICollidable, Bounds } from './types';

@singleton()
export class CollisionManager {
	private collidables: ICollidable[] = [];

	/**
	 * Register an object for collision detection
	 */
	register(obj: ICollidable): void {
		if (!this.collidables.includes(obj)) {
			this.collidables.push(obj);
		}
	}

	/**
	 * Unregister an object from collision detection
	 */
	unregister(obj: ICollidable): void {
		const index = this.collidables.indexOf(obj);
		if (index > -1) {
			this.collidables.splice(index, 1);
		}
	}

	/**
	 * Clear all registered collidables
	 */
	clear(): void {
		this.collidables = [];
	}

	/**
	 * Check collisions between a subject and all registered collidables
	 * Calls onCollision on both objects when a collision is detected
	 */
	checkCollisions(subject: ICollidable): void {
		if (!subject.isActive()) return;

		const subjectBounds = subject.getBounds();

		for (const obj of this.collidables) {
			// Skip self and inactive objects
			if (obj === subject || !obj.isActive()) continue;

			const objBounds = obj.getBounds();

			if (this.isColliding(subjectBounds, objBounds)) {
				// Bi-directional collision notification
				obj.onCollision(subject);
				subject.onCollision(obj);
			}
		}
	}

	/**
	 * AABB (Axis-Aligned Bounding Box) collision detection
	 */
	private isColliding(a: Bounds, b: Bounds): boolean {
		return (
			a.x < b.x + b.width && a.x + a.width > b.x && a.y < b.y + b.height && a.y + a.height > b.y
		);
	}
}
